module.exports = __webpack_public_path__ + "img/germany-genitourinary-diseases-female.5594cc20.png";